function assign() {
    var args = Array.prototype.slice(arguments);
    var output = args.unshift();

    for (var i = 0; i < args.length; i++) {
        copyInto(output, args[i])
    }

    return output
}

function copyInto(a, b) {
    var keys = b ? Object.keys(b) : []
    for (var i = 0; i < keys.length; i++) {
        a[keys[i]] = b[keys[i]]
    }
}

function build(opts) {
    var element = document.createElement(opts.tag || 'div')
    element.className = opts.className
    element.onclick = opts.click

    if (opts.children) {
        opts.children = opts.children instanceof Array || opts.children instanceof HTMLCollection ? opts.children : [opts.children]
        for (const child of opts.children) {
            if (typeof child === 'string') {
                element.innerHTML += child
            } else if (child instanceof HTMLElement) {
                element.appendChild(child)
            } else if (child) {
                element.appendChild(build(child))
            }
        }
    }
    return element
}

var _container = null
var _shown = false
var _history = []
function getContainer() {
    if (!_container) {
        _container = build({
            className: 'ModalContainer',
            click: Modal.close.bind(Modal),
            children:  {
                className: 'ModalContainer-overlay',
                children: {
                    className: 'ModalContainer-scroll',
                    children: {
                        className: 'ModalContainer-modal'
                    }
                }
            }
        })
        document.body.append(_container)
    }
    return _container
}

function getModalElement() {
    return getContainer().querySelector('.ModalContainer-modal')
}

function showContainer() {
    if (!_shown) getContainer().classList.add('ModalContainer--show')
    _shown = true
}

function hideContainer() {
    if (_shown) getContainer().classList.remove('ModalContainer--show')
    _shown = false
}

function clearChildren(node) {
    var op = []
    for (var i = 0; i < node.children.length; i++) {
        var child = node.children[i]
        node.removeChild(child)
        op.push(child)
    }
    return op
}

function appendChildren(node, children) {
    for (var i = 0; i < children.length; i++) {
        node.appendChild(children[i])
    }
}

function createModal(title, content, buttons) {
    return build({
        className: 'Modal',
        children: [
            {
                className: 'Modal-header',
                children: [
                    {
                        className: 'Modal-title',
                        children: title
                    },
                    { className: 'Modal-close', click: Modal.close.bind(Modal) }
                ]
            },
            {
                className: 'Modal-content',
                children: content
            },
            buttons && {
                className: 'Modal-buttons',
                children: Object.keys(buttons).map(label => {
                    let handler = buttons[label]
                    if (handler === 'close') handler = Modal.close.bind(Modal)

                    return {
                        tag: 'button',
                        className: 'Modal-button btn btn--caps btn--block',
                        click: handler,
                        children: label
                    }
                })
            }
        ]
    })
}

export const Modal = {
    show: function(title, content, buttons) {
        var element = getModalElement()

        if (_shown) _history.push(clearChildren(element))

        let modal = createModal(title, content, buttons)

        modal.onclick = function(e) { e.stopPropagation(); };

        element.appendChild(modal)

        showContainer()
    },

    restore: function() {
        if (!_shown) return

        var element = getModalElement()

        clearChildren(element)

        if (!_history.length) {
            hideContainer()
        } else {
            appendChildren(element, _history.pop())
        }
    },

    close: function() {
        _history = []
        this.restore()
    }
};
